// Author Liu Cui Cui
// Date 2024-12-31 13:43:55

import * as model from "@/model/sithMes/quality/SithMesQualityDocumentModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityDocument(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
    })
    .buildStore()
